$(document).ready(function() {

    // address page
    $('.edit-spacer input[type="hidden"][name="_method"][value="put"]').remove();
  
   countDownIni('.flip-countdown,.js-flip-countdown');
  $(".menu-lnk.has-item").hover(function(){
     $(this).toggleClass("menu_active");
    $(this).find(".menu-dropdown").toggleClass("open_menu");
    $("body").toggleClass("no-scroll");
  });
jQuery('.mobile-menu-wrapper').insertAfter('.site-footer');
    var contentDiv = $('#WebPixelsManagerSandboxContainer');
  $('footer').after(contentDiv);
    /********* On scroll heder Sticky *********/
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll >= 50) {
            $("header").addClass("head-sticky");
        } else {
            $("header").removeClass("head-sticky");
        }
    });   
    /********* Wrapper top space ********/
    var header_hright = $('header').outerHeight();
    $('header').next('.wrapper').css('margin-top', header_hright + 'px');  
    /********* Announcebar hide ********/
    $('#announceclose').click(function () {
        $('.announcebar').slideUp();
    }); 

   /*********  size Popup  ********/ 
      $(".size-btn").click(function() { 
        $(".size-popup").toggleClass("active"); 
        $("body").toggleClass("no-scroll");
    });
    $(".close-search").click(function() { 
        $(".size-popup").removeClass("active"); 
        $("body").removeClass("no-scroll");
    });
    $(".close-btn").click(function() { 
        $(".size-popup").removeClass("active"); 
        $("body").removeClass("no-scroll");
    });
  /********* Cart Popup ********/
    if ($('body').hasClass('cart')) {
      // Disable click on the cart-header div
      $('.cart-header').on('click', function(event) {
        event.preventDefault();
        return false;
      });
    }
    else{
    $('.cart-header').on('click', function (e) {
    e.preventDefault();
    setTimeout(function () {
      $('body').addClass('no-scroll cartOpen');
      $('.overlay').addClass('cart_overlay');
    }, 50);
  });
  }
  $('body').on('click', '.overlay.cart_overlay, .closecart', function (e) {
    e.preventDefault();
    $('.overlay').removeClass('cart_overlay');
    $('body').removeClass('no-scroll cartOpen');
    $('.coupon-popup').removeClass('active');
    $('.gift-popup').removeClass('active');
  });

   /*********coupon popup ********/
  $(document).on('click', '.coupan-icon', function () {
    $(".coupon-popup").toggleClass("active");
  });
  $(document).on('click', '.gift-icon', function () {
    $(".coupon-popup").removeClass("active");
  });
  $(document).on('click', '.close-coupon', function () {
    $(".coupon-popup").removeClass("active");
  });
  
  // coupan code
    $('body').on('keyup','.discount-coupon', function() {
     var apply_href = $('.apply').attr("href").split('discount=')[0];
     var val = $(this).val();
      $('.apply').attr("href",apply_href+'discount='+val);
       $('.apply').trigger('click');
    });

  /*********gift popup ********/
  $(document).on('click', '.gift-icon', function () {
    $(".gift-popup").toggleClass("active");
  });
  $(document).on('click', '.coupan-icon', function () {
    $(".gift-popup ").removeClass("active");
  });
  $(document).on('click', '.close-gift', function () {
    $(".gift-popup").removeClass("active");
  });
    /********* Mobile Menu ********/  
    $('.mobile-menu-button').on('click',function(e){
        e.preventDefault();
        setTimeout(function(){
            $('body').addClass('no-scroll active-menu');
            $(".mobile-menu-wrapper").toggleClass("active-menu");
            $('.overlay').addClass('menu-overlay');
        }, 50);
    }); 
    $('body').on('click','.overlay.menu-overlay, .menu-close-icon svg', function(e){
        e.preventDefault(); 
        $('body').removeClass('no-scroll active-menu');
        $(".mobile-menu-wrapper").removeClass("active-menu");
        $('.overlay').removeClass('menu-overlay');
    });

    /********* Mobile Filter Popup ********/
    $('.mobile-facets__open').on('click', function (e) {
      $('body').addClass('mobile-open no-scroll');
      $('.overlay').addClass('active');
    });
    $('.overlay,.close-filter,.apply-btn').on('click', function (e) {
      $('body').removeClass('mobile-open no-scroll overflow-hidden-mobile');
      $('.overlay').removeClass('active');
    });
       /*********  Header Search Popup  ********/ 
       $(".mobile-search-btn a").click(function() { 
        $(".search-popup").toggleClass("active"); 
        $("body").toggleClass("no-scroll");
    });
    $(".close-search").click(function() { 
        $(".search-popup").removeClass("active"); 
        $("body").removeClass("no-scroll");
    });
    /******* Cookie Js *******/
    $('.cookie-close').click(function () {
        $('.cookie').slideUp();
    });
    /******* Subscribe popup Js *******/
     if ($('.subscribe-popup').length > 0) {
    $('body').addClass('no-scroll');
  }
    $('.close-sub-btn').click(function () {
      $('.subscribe-popup').slideUp(); 
      $(".subscribe-overlay").removeClass("open");
      $('body').removeClass('no-scroll');
    });    
    /*********  Multi-level accordion nav  ********/ 
    $('.acnav-label').click(function () {
        var label = $(this);
        var parent = label.parent('.has-children');
        var list = label.siblings('.acnav-list');
        if (parent.hasClass('is-open')) {
            list.slideUp('fast');
            parent.removeClass('is-open');
        }
        else {
            list.slideDown('fast');
            parent.addClass('is-open');
        }
    });  
    /****  TAB Js ****/
    $('ul.tabs li').click(function(){
        var $this = $(this);
        var $theTab = $(this).attr('data-tab');
        console.log($theTab);
        if($this.hasClass('active')){
          // do nothing
        } else{
          $this.closest('.tabs-wrapper').find('ul.tabs li, .tabs-container .tab-content').removeClass('active');
          $('.tabs-container .tab-content[id="'+$theTab+'"], ul.tabs li[data-tab="'+$theTab+'"]').addClass('active');
        }
    });  


    // HOME BANNER SLIDER JS //
    $('.banner-slider').slick({
        arrows: false,
        dots: true,
        autoplay: false,
        speed: 2000,
        autoplaySpeed: 1000,
        slidesToScroll: 1,  
        slidesToShow: 1,
        swipeToSlide: true,
        swipeToSlide: true,
        asNavFor:'.banner-bottom-slider',
    });

    $('.banner-bottom-slider').slick({
        dots: false,
        speed: 1000, 
        slidesToScroll: 1,
        touchMove: true,
        focusOnSelect: true,
        loop: true,
        infinite: true,
        arrows:false,
        focusOnSelect: true,
        slidesToShow: 2,
        asNavFor:'.banner-slider',
        responsive: [  
            {
            breakpoint:768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1 
                }
            },
            {
            breakpoint:576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1 
                }
            }  
        ]
    });

    if($('.home-news-slider').length > 0 ){
        $('.home-news-slider').slick({
            autoplay: false, 
            slidesToShow: 4,
            speed: 1000,
            slidesToScroll: 1,  
            centerMode: true,
            centerPadding: 0,
            prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.266266 0.26035C-0.088756 0.607483 -0.088756 1.1703 0.266266 1.51743L2.80526 4L0.266267 6.48257C-0.0887555 6.8297 -0.0887554 7.39252 0.266267 7.73965C0.621289 8.08678 1.19689 8.08678 1.55192 7.73965L4.73373 4.62854C5.08876 4.28141 5.08876 3.71859 4.73373 3.37146L1.55191 0.26035C1.19689 -0.0867829 0.621288 -0.0867828 0.266266 0.26035Z" fill="#51734E"></path></svg></button>',
            nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.266266 0.26035C-0.088756 0.607483 -0.088756 1.1703 0.266266 1.51743L2.80526 4L0.266267 6.48257C-0.0887555 6.8297 -0.0887554 7.39252 0.266267 7.73965C0.621289 8.08678 1.19689 8.08678 1.55192 7.73965L4.73373 4.62854C5.08876 4.28141 5.08876 3.71859 4.73373 3.37146L1.55191 0.26035C1.19689 -0.0867829 0.621288 -0.0867828 0.266266 0.26035Z" fill="#51734E"></path></svg></button>',
            dots: false,
            buttons: false,
            responsive: [  
                {
                    breakpoint:992,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1 
                        }
                    },
                {
                breakpoint:768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1 
                    }
                },
                {
                breakpoint:576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1 
                    }
                }  
            ]
        });
    }

    if($('.your-career-slider').length > 0 ){
        $('.your-career-slider').slick({
            autoplay: false, 
            slidesToShow: 2,
            speed: 1000,
            slidesToScroll: 1,  
            centerMode: false,
            centerPadding: 0,
            prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.266266 0.26035C-0.088756 0.607483 -0.088756 1.1703 0.266266 1.51743L2.80526 4L0.266267 6.48257C-0.0887555 6.8297 -0.0887554 7.39252 0.266267 7.73965C0.621289 8.08678 1.19689 8.08678 1.55192 7.73965L4.73373 4.62854C5.08876 4.28141 5.08876 3.71859 4.73373 3.37146L1.55191 0.26035C1.19689 -0.0867829 0.621288 -0.0867828 0.266266 0.26035Z" fill="#51734E"></path></svg></button>',
            nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.266266 0.26035C-0.088756 0.607483 -0.088756 1.1703 0.266266 1.51743L2.80526 4L0.266267 6.48257C-0.0887555 6.8297 -0.0887554 7.39252 0.266267 7.73965C0.621289 8.08678 1.19689 8.08678 1.55192 7.73965L4.73373 4.62854C5.08876 4.28141 5.08876 3.71859 4.73373 3.37146L1.55191 0.26035C1.19689 -0.0867829 0.621288 -0.0867828 0.266266 0.26035Z" fill="#51734E"></path></svg></button>',
            dots: false,
            buttons: false,
            responsive: [  
                {
                    breakpoint:1200,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1 
                        }
                    },
                {
                breakpoint:576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1 
                    }
                }  
            ]
        });
    }


    if($('.job-slider-home').length > 0 ){
        $('.job-slider-home').slick({
            autoplay: false, 
            slidesToShow: 4,
            speed: 1000,
            slidesToScroll: 1,  
            centerMode: false,
            centerPadding: 0,
            prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.266266 0.26035C-0.088756 0.607483 -0.088756 1.1703 0.266266 1.51743L2.80526 4L0.266267 6.48257C-0.0887555 6.8297 -0.0887554 7.39252 0.266267 7.73965C0.621289 8.08678 1.19689 8.08678 1.55192 7.73965L4.73373 4.62854C5.08876 4.28141 5.08876 3.71859 4.73373 3.37146L1.55191 0.26035C1.19689 -0.0867829 0.621288 -0.0867828 0.266266 0.26035Z" fill="#51734E"></path></svg></button>',
            nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.266266 0.26035C-0.088756 0.607483 -0.088756 1.1703 0.266266 1.51743L2.80526 4L0.266267 6.48257C-0.0887555 6.8297 -0.0887554 7.39252 0.266267 7.73965C0.621289 8.08678 1.19689 8.08678 1.55192 7.73965L4.73373 4.62854C5.08876 4.28141 5.08876 3.71859 4.73373 3.37146L1.55191 0.26035C1.19689 -0.0867829 0.621288 -0.0867828 0.266266 0.26035Z" fill="#51734E"></path></svg></button>',
            dots: false,
            buttons: false,
            responsive: [  
                {
                    breakpoint:992,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1 
                        }
                    },
                {
                breakpoint:768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1 
                    }
                },
                {
                breakpoint:576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1 
                    }
                }  
            ]
        });
    }


    if($('.home-blog-slider').length > 0 ){
        $('.home-blog-slider').slick({
            autoplay: false, 
            slidesToShow: 3,
            speed: 1000,
            slidesToScroll: 1,  
            centerMode: false,
            centerPadding: 0,
            prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.266266 0.26035C-0.088756 0.607483 -0.088756 1.1703 0.266266 1.51743L2.80526 4L0.266267 6.48257C-0.0887555 6.8297 -0.0887554 7.39252 0.266267 7.73965C0.621289 8.08678 1.19689 8.08678 1.55192 7.73965L4.73373 4.62854C5.08876 4.28141 5.08876 3.71859 4.73373 3.37146L1.55191 0.26035C1.19689 -0.0867829 0.621288 -0.0867828 0.266266 0.26035Z" fill="#51734E"></path></svg></button>',
            nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.266266 0.26035C-0.088756 0.607483 -0.088756 1.1703 0.266266 1.51743L2.80526 4L0.266267 6.48257C-0.0887555 6.8297 -0.0887554 7.39252 0.266267 7.73965C0.621289 8.08678 1.19689 8.08678 1.55192 7.73965L4.73373 4.62854C5.08876 4.28141 5.08876 3.71859 4.73373 3.37146L1.55191 0.26035C1.19689 -0.0867829 0.621288 -0.0867828 0.266266 0.26035Z" fill="#51734E"></path></svg></button>',
            dots: false,
            buttons: false,
            responsive: [  
                {
                    breakpoint:992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1 
                        }
                    },
                {
                breakpoint:768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1 
                    }
                },
                {
                breakpoint:576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1 
                    }
                }  
            ]
        });
    }

    if($('.event-slider').length > 0 ){
        $('.event-slider').slick({
            autoplay: false, 
            slidesToShow: 2,
            speed: 1000,
            slidesToScroll: 1,  
            centerMode: false,
            centerPadding: 0,
            prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.266266 0.26035C-0.088756 0.607483 -0.088756 1.1703 0.266266 1.51743L2.80526 4L0.266267 6.48257C-0.0887555 6.8297 -0.0887554 7.39252 0.266267 7.73965C0.621289 8.08678 1.19689 8.08678 1.55192 7.73965L4.73373 4.62854C5.08876 4.28141 5.08876 3.71859 4.73373 3.37146L1.55191 0.26035C1.19689 -0.0867829 0.621288 -0.0867828 0.266266 0.26035Z" fill="#51734E"></path></svg></button>',
            nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.266266 0.26035C-0.088756 0.607483 -0.088756 1.1703 0.266266 1.51743L2.80526 4L0.266267 6.48257C-0.0887555 6.8297 -0.0887554 7.39252 0.266267 7.73965C0.621289 8.08678 1.19689 8.08678 1.55192 7.73965L4.73373 4.62854C5.08876 4.28141 5.08876 3.71859 4.73373 3.37146L1.55191 0.26035C1.19689 -0.0867829 0.621288 -0.0867828 0.266266 0.26035Z" fill="#51734E"></path></svg></button>',
            dots: false,
            buttons: false,
            responsive: [  
                {
                    breakpoint:991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1 
                        }
                    },
                {
                breakpoint:768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1 
                    }
                },
                {
                breakpoint:576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1 
                    }
                }  
            ]
        });
    }

    if($('.related-event-slider').length > 0 ){
        $('.related-event-slider').slick({
            autoplay: false, 
            slidesToShow: 2,
            speed: 1000,
            slidesToScroll: 1,  
            centerMode: false,
            centerPadding: 0,
            prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.266266 0.26035C-0.088756 0.607483 -0.088756 1.1703 0.266266 1.51743L2.80526 4L0.266267 6.48257C-0.0887555 6.8297 -0.0887554 7.39252 0.266267 7.73965C0.621289 8.08678 1.19689 8.08678 1.55192 7.73965L4.73373 4.62854C5.08876 4.28141 5.08876 3.71859 4.73373 3.37146L1.55191 0.26035C1.19689 -0.0867829 0.621288 -0.0867828 0.266266 0.26035Z" fill="#51734E"></path></svg></button>',
            nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.266266 0.26035C-0.088756 0.607483 -0.088756 1.1703 0.266266 1.51743L2.80526 4L0.266267 6.48257C-0.0887555 6.8297 -0.0887554 7.39252 0.266267 7.73965C0.621289 8.08678 1.19689 8.08678 1.55192 7.73965L4.73373 4.62854C5.08876 4.28141 5.08876 3.71859 4.73373 3.37146L1.55191 0.26035C1.19689 -0.0867829 0.621288 -0.0867828 0.266266 0.26035Z" fill="#51734E"></path></svg></button>',
            dots: false,
            buttons: false,
            responsive: [  
                {
                    breakpoint:991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1 
                        }
                    },
                {
                breakpoint:768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1 
                    }
                },
                {
                breakpoint:576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1 
                    }
                }  
            ]
        });
    }
    if($('.related-item-slider').length > 0 ){
        $('.related-item-slider').slick({
            autoplay: false, 
            slidesToShow: 3,
            speed: 1000,
            slidesToScroll: 1,  
            centerMode: false,
            centerPadding: 0,
            prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.266266 0.26035C-0.088756 0.607483 -0.088756 1.1703 0.266266 1.51743L2.80526 4L0.266267 6.48257C-0.0887555 6.8297 -0.0887554 7.39252 0.266267 7.73965C0.621289 8.08678 1.19689 8.08678 1.55192 7.73965L4.73373 4.62854C5.08876 4.28141 5.08876 3.71859 4.73373 3.37146L1.55191 0.26035C1.19689 -0.0867829 0.621288 -0.0867828 0.266266 0.26035Z" fill="#51734E"></path></svg></button>',
            nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.266266 0.26035C-0.088756 0.607483 -0.088756 1.1703 0.266266 1.51743L2.80526 4L0.266267 6.48257C-0.0887555 6.8297 -0.0887554 7.39252 0.266267 7.73965C0.621289 8.08678 1.19689 8.08678 1.55192 7.73965L4.73373 4.62854C5.08876 4.28141 5.08876 3.71859 4.73373 3.37146L1.55191 0.26035C1.19689 -0.0867829 0.621288 -0.0867828 0.266266 0.26035Z" fill="#51734E"></path></svg></button>',
            dots: false,
            buttons: false,
            responsive: [  
                {
                    breakpoint:991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1 
                        }
                    },
                {
                breakpoint:768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1 
                    }
                },
                {
                breakpoint:576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1 
                    }
                }  
            ]
        });
    }

    if($('.blog-slider2').length > 0 ){
        $('.blog-slider2').slick({
            autoplay: true, 
            slidesToShow: 3,
            speed: 1000,
            slidesToScroll: 1,  
            centerMode: true,
            centerPadding: 0,
            prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.266266 0.26035C-0.088756 0.607483 -0.088756 1.1703 0.266266 1.51743L2.80526 4L0.266267 6.48257C-0.0887555 6.8297 -0.0887554 7.39252 0.266267 7.73965C0.621289 8.08678 1.19689 8.08678 1.55192 7.73965L4.73373 4.62854C5.08876 4.28141 5.08876 3.71859 4.73373 3.37146L1.55191 0.26035C1.19689 -0.0867829 0.621288 -0.0867828 0.266266 0.26035Z" fill="#51734E"></path></svg></button>',
            nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.266266 0.26035C-0.088756 0.607483 -0.088756 1.1703 0.266266 1.51743L2.80526 4L0.266267 6.48257C-0.0887555 6.8297 -0.0887554 7.39252 0.266267 7.73965C0.621289 8.08678 1.19689 8.08678 1.55192 7.73965L4.73373 4.62854C5.08876 4.28141 5.08876 3.71859 4.73373 3.37146L1.55191 0.26035C1.19689 -0.0867829 0.621288 -0.0867828 0.266266 0.26035Z" fill="#51734E"></path></svg></button>',
            dots: false,
            buttons: false,
            responsive: [  
                {
                    breakpoint:991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1 
                        }
                    } ,
                {
                breakpoint:576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1 
                    }
                }
            ]
        });
    }

  // Slick lightbox 
    if($('.lightbox').length>0) {
        $('.lightbox').slickLightbox({
           itemSelector: 'a.open-lightbox',
           caption: 'caption',
           prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
           nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
           navigateByKeyboard: true,
           layouts: {
              closeButton: '<button class="close"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none"><path d="M27.7618 25.0008L49.4275 3.33503C50.1903 2.57224 50.1903 1.33552 49.4275 0.572826C48.6647 -0.189868 47.428 -0.189965 46.6653 0.572826L24.9995 22.2386L3.33381 0.572826C2.57102 -0.189965 1.3343 -0.189965 0.571605 0.572826C-0.191089 1.33562 -0.191186 2.57233 0.571605 3.33503L22.2373 25.0007L0.571605 46.6665C-0.191186 47.4293 -0.191186 48.666 0.571605 49.4287C0.952952 49.81 1.45285 50.0007 1.95275 50.0007C2.45266 50.0007 2.95246 49.81 3.3339 49.4287L24.9995 27.763L46.6652 49.4287C47.0465 49.81 47.5464 50.0007 48.0463 50.0007C48.5462 50.0007 49.046 49.81 49.4275 49.4287C50.1903 48.6659 50.1903 47.4292 49.4275 46.6665L27.7618 25.0008Z" fill="white"></path></svg></button>'
           }
        });
      
      $(".pdp-main-media").click(function() {
        if($('a.pdp-main-media').hasClass('open-lightbox')){
          $('body').addClass('no-scroll');
        }else{
          $('body').removeClass('no-scroll');
        }
      });
      $('body').on('click', '.slick-lightbox-inner .close, .slick-lightbox-hide', function() {
        $('body').removeClass('no-scroll');
      });
    }
  
    // product slider zoom
    $('.pdp-main-media.zoom').each(function() {
      $(this).zoom({
        url: false,
        callback: false,
        target: false,
        duration: 120,
        on: 'mouseover', // other options: grab, click, toggle
        touch: true, // enables a touch fallback
        onZoomIn: false,
        onZoomOut: false,
        magnify: 2
      });
    });


 // currency-nice-select
          $('body').on('click', '.currency .nice-select', function (e) {
            e.stopPropagation(); // Stop the event from propagating to the body
            $(this).toggleClass('open');
          });
          $('body').on('click', function (e) {
            $('.currency .nice-select').removeClass('open');
          });
          
          function currencyFormSubmit(event) {
            event.target.form.submit();
          }
          
          document.querySelectorAll('.currency .nice-select .list li').forEach(function (currencyItem) {
            currencyItem.addEventListener('click', function () {
              // Trigger change event on the associated select element
              var selectElement = this.closest('.currency').querySelector('select');
              if (selectElement) {
                // Set the selected option based on the data-currency attribute of the clicked li
                selectElement.value = this.dataset.currency;
                
                // Trigger change event
                var event = new Event('change', { bubbles: true });
                selectElement.dispatchEvent(event);
          
                // Submit the form
                currencyFormSubmit({ target: selectElement });
              }
            });
          });

  // notify me
  $('body').on('click','.notify-btn', function(e) {
      e.preventDefault();
      $('body').addClass('no-scroll notify-active');
      $('.out-of-stock-form,.overlay').addClass('active');
    });
   $('body').on('click','.overlay,.notify-popup-close', function(e) {
      e.preventDefault();
     $('body').removeClass('no-scroll notify-active');
      $('.out-of-stock-form,.overlay').removeClass('active');
    });



// sticky addtocart button

if($('body').hasClass('product')){
$.fn.isInViewport = function() {
    var elementTop = this.offset().top;
    var elementBottom = elementTop + this.outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

    $(window).scroll(function() {
        if ($('.cart-btn.product-button').isInViewport()) {
          $('.products-add-cart-sticky').removeClass('show-btn');
        } else {
          $('.products-add-cart-sticky').addClass('show-btn');
        }
    });
    }

   $(".stickyOpt.nice-select").on('click', function(){
		$(this).toggleClass('open');
    });
    $(".stickyOpt .vrOpt").on('click', function(e){
        var sectionId = $('.product-main-section .container').attr('data-section-id');
		var number = $(this).data('no');
        $(".stickyOpt .selectedOpt").html($(this).html());
      	$(this).toggleClass('open');
      	this.productvariants = JSON.parse(document.getElementById('variants'+sectionId).innerHTML);
        var stOpt = this.productvariants[number],
            o1 = stOpt.option1, o2 = stOpt.option2, o3 = stOpt.option3;
        $('.stickCtImg').attr('src', stOpt.featured_image.src+'&width=100');
        if($('select.single-option-selector').length){
        } else {
            if(o2 != null){var stOpt2 = o2.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt2+"']").prop("checked",true)}
            if(o3 != null){var stOpt3 = o3.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt3+"']").prop("checked",true)}
            if(o1 != null){var stOpt1 = o1.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt1+"']").trigger('click')}
        }
    });
  
      $(".stickyQty .quantity__button").on("click", function(){
      var qtyField = $('.mianQty'),oldValue = $(qtyField).val(),newVal = 1;
      if ($(this).is(".quantity-increment")) {
        newVal = parseInt(oldValue) + 1;
      } else if (oldValue > 1) {
        newVal = parseInt(oldValue) - 1;
      }
      $(qtyField).val(newVal).trigger('change');
    });
    $('.mianQty').on("change", function(){
      $('#stquantity').val($(this).val());
    });
// end sticky
  
  
  
  
// quickview
  $('body').on('click', '.quickview-close', function(e) {
    e.preventDefault();
    $('.quickview-popup').hide();
    $('body').removeClass('no-scroll quick-active');
  });
  
  $('body').on('click', '.quickview-btn', function(e) {
    e.preventDefault();
    $('body').addClass('no-scroll quick-active');
    var href= '/products/'+$(this).find('a').data('handle')+'?view=qv';
    $.get(href, function(product) {
      $('.quickview_popup_data').html(product);
      $('.qv_slider').slick({
          autoplay: false,
          slidesToShow: 1,
          speed: 1000,
          slidesToScroll: 1,
          arrows: true,
          prevArrow: '<button class="slide-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="4" height="6" viewBox="0 0 4 6" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.65976 0.662719C0.446746 0.879677 0.446746 1.23143 0.65976 1.44839L2.18316 3L0.65976 4.55161C0.446747 4.76856 0.446747 5.12032 0.65976 5.33728C0.872773 5.55424 1.21814 5.55424 1.43115 5.33728L3.34024 3.39284C3.55325 3.17588 3.55325 2.82412 3.34024 2.60716L1.43115 0.662719C1.21814 0.445761 0.872773 0.445761 0.65976 0.662719Z" fill="white"></path></svg></button>',
          nextArrow: '<button class="slide-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="4" height="6" viewBox="0 0 4 6" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.65976 0.662719C0.446746 0.879677 0.446746 1.23143 0.65976 1.44839L2.18316 3L0.65976 4.55161C0.446747 4.76856 0.446747 5.12032 0.65976 5.33728C0.872773 5.55424 1.21814 5.55424 1.43115 5.33728L3.34024 3.39284C3.55325 3.17588 3.55325 2.82412 3.34024 2.60716L1.43115 0.662719C1.21814 0.445761 0.872773 0.445761 0.65976 0.662719Z" fill="white"></path></svg></button>',
          dots: false,
          buttons: false,
          infinite: false,
          loop: false
      });

    });
    $('.quickview-popup').show();
  });

  $('body').on('change', '.quickview_popup_data .size-select .button', function() {
    var data_val = $(this).children('input:checked').val();
   $(this).parents('.size-select').find('.option-label').text(data_val);
   
    var selectedValues = [];

    // Collect selected option values
    $('.quickview_popup_data .size-select .button input:checked').each(function() {
    var selectedValue = $(this).val();
    if (selectedValue) {
      selectedValues.push(selectedValue);
    }
  });
var joinedValues = selectedValues.join(' / ');


    $('.variant-qv').each(function() {
     var variant_title = $(this).data('title'); 
     var variant_img = $('.variant-qv[data-title="'+variant_title+'"]').data('img');
     var variant_price = $('.variant-qv[data-title="'+variant_title+'"]').data('price');
     var qv_btn =  $('.variant-qv[data-title="'+variant_title+'"]').data('avail');
     var variant_id = $('.variant-qv[data-title="'+variant_title+'"]').data('id');
      variant_title = String(variant_title);
      joinedValues = String(joinedValues);
      
      if(variant_title === joinedValues){
        
      var slideIndex = $('.qv_slider .qv-pro-slider-img img[data-img="'+variant_img+'"]').parent().index();
      $('.qv_slider').slick('slickGoTo', slideIndex)
        
        $('.qv-price').find('.price-item--regular').text(variant_price);

        if(qv_btn === true ){
          $('#quick-view-temp .product-form__submit').find('span').text('Add to Cart');
          $('#quick-view-temp .product-form__submit').removeAttr('disabled');
        }else{
          $('#quick-view-temp .product-form__submit').find('span').text('Sold out');
          $('#quick-view-temp .product-form__submit').attr('disabled', 'disabled');
        }

        $('input[name="id"]').val(variant_id);
        
      }
  });
  
  });
// end quickview


      if($('.featured-cat-slider').length > 0 ){
        $('.featured-cat-slider').slick({
            autoplay: false, 
            slidesToShow: 4,
            speed: 1000,
            slidesToScroll: 1,  
            buttons: false,
            prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.266266 0.26035C-0.088756 0.607483 -0.088756 1.1703 0.266266 1.51743L2.80526 4L0.266267 6.48257C-0.0887555 6.8297 -0.0887554 7.39252 0.266267 7.73965C0.621289 8.08678 1.19689 8.08678 1.55192 7.73965L4.73373 4.62854C5.08876 4.28141 5.08876 3.71859 4.73373 3.37146L1.55191 0.26035C1.19689 -0.0867829 0.621288 -0.0867828 0.266266 0.26035Z" fill="#51734E"></path></svg></button>',
            nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.266266 0.26035C-0.088756 0.607483 -0.088756 1.1703 0.266266 1.51743L2.80526 4L0.266267 6.48257C-0.0887555 6.8297 -0.0887554 7.39252 0.266267 7.73965C0.621289 8.08678 1.19689 8.08678 1.55192 7.73965L4.73373 4.62854C5.08876 4.28141 5.08876 3.71859 4.73373 3.37146L1.55191 0.26035C1.19689 -0.0867829 0.621288 -0.0867828 0.266266 0.26035Z" fill="#51734E"></path></svg></button>',
            dots: false,
            responsive: [ 
                {
                    breakpoint: 1400,
                    settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1   
                    }
                },  
                {
                breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1 
                    }
                },
                {
                breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2 
                    }
                },
                {
                  breakpoint: 450,
                      settings: {
                          slidesToShow: 1,
                          slidesToScroll: 1 
                      }
                  }
            ]
        });
    }
  

      /** PDP slider **/
    $('.pdp-main-slider').slick({
        dots: false,
        infinite: true,
        speed: 1000,
        loop: true,
        slidesToShow: 1,
        arrows: false,
        asNavFor: '.pdp-thumb-slider',
    });
    $('.pdp-thumb-slider').slick({
      prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.266266 0.26035C-0.088756 0.607483 -0.088756 1.1703 0.266266 1.51743L2.80526 4L0.266267 6.48257C-0.0887555 6.8297 -0.0887554 7.39252 0.266267 7.73965C0.621289 8.08678 1.19689 8.08678 1.55192 7.73965L4.73373 4.62854C5.08876 4.28141 5.08876 3.71859 4.73373 3.37146L1.55191 0.26035C1.19689 -0.0867829 0.621288 -0.0867828 0.266266 0.26035Z" fill="#51734E"></path></svg></button>',
            nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.266266 0.26035C-0.088756 0.607483 -0.088756 1.1703 0.266266 1.51743L2.80526 4L0.266267 6.48257C-0.0887555 6.8297 -0.0887554 7.39252 0.266267 7.73965C0.621289 8.08678 1.19689 8.08678 1.55192 7.73965L4.73373 4.62854C5.08876 4.28141 5.08876 3.71859 4.73373 3.37146L1.55191 0.26035C1.19689 -0.0867829 0.621288 -0.0867828 0.266266 0.26035Z" fill="#51734E"></path></svg></button>',
            dots: false,
        asNavFor: '.pdp-main-slider', 
        speed: 1000, 
        slidesToScroll: 1,
        touchMove: true,
        focusOnSelect: true,
        loop: true,
        infinite: true,
        focusOnSelect: true,
        slidesToShow: 4,
        responsive: [{
                breakpoint: 1261,
                settings: {
                    slidesToShow: 3 
                }
            } 
        ]   
    });

  
});
/******  STEPPY FORM  CSS  ******/
var totalSteps = $(".steps li").length;

$(".submit").on("click", function(){
  return false; 
});
$(".steps li:nth-of-type(1)").addClass("active");
$(".myContainer .step-container:nth-of-type(1)").addClass("active");
$(".step-container").on("click", ".next", function() { 
  $(".steps li").eq($(this).parents(".step-container").index() + 1).addClass("active"); 
  $(this).parents(".step-container").removeClass("active").next().addClass("active");   
});
$(".step-container").on("click", ".back", function() {  
  $(".steps li").eq($(this).parents(".step-container").index() - totalSteps).removeClass("active"); 
  $(this).parents(".step-container").removeClass("active").prev().addClass("active"); 
}); 
/******  STEPPY FORM  CSS  End******/
if ($(".my-acc-column").length > 0) {
    jQuery(function ($) {
        var topMenuHeight = $("#daccount-nav").outerHeight();
        $("#account-nav").menuScroll(topMenuHeight);
        $(".account-list li:first-child").addClass("active");
    });
    // COPY THE FOLLOWING FUNCTION INTO ANY SCRIPTS
    jQuery.fn.extend({
        menuScroll: function (offset) {
            // Declare all global variables
            var topMenu = this;
            var topOffset = offset ? offset : 0;
            var menuItems = $(topMenu).find("a");
            var lastId;
            // Save all menu items into scrollItems array
            var scrollItems = $(menuItems).map(function () {
                var item = $($(this).attr("href"));
                if (item.length) {
                    return item;
                }
            });
            // When the menu item is clicked, get the #id from the href value, then scroll to the #id element
            $(topMenu).on("click", "a", function (e) {
                var href = $(this).attr("href");
                var offsetTop = href === "#" ? 0 : $(href).offset().top - topOffset;
                function checkWidth() {
                    var windowSize = $(window).width();
                    if (windowSize <= 767) {
                        $('html, body').stop().animate({
                            scrollTop: offsetTop - 200
                        }, 300);
                    }
                    else {
                        $('html, body').stop().animate({
                            scrollTop: offsetTop - 135
                        }, 300);
                    }
                }
                // Execute on load
                checkWidth();
                // Bind event listener
                $(window).resize(checkWidth);
                e.preventDefault();
            });
            // When page is scrolled
            $(window).scroll(function () {
                function checkWidth() {
                    var windowSize = $(window).width();
                    if (windowSize <= 767) {
                        var nm = $("html").scrollTop();
                        var nw = $("body").scrollTop();
                        var fromTop = (nm > nw ? nm : nw) + topOffset;
                        // When the page pass one #id section, return all passed sections to scrollItems and save them into new array current
                        var current = $(scrollItems).map(function () {
                            if ($(this).offset().top - 250 <= fromTop)
                                return this;
                        });
                        // Get the most recent passed section from current array
                        current = current[current.length - 1];
                        var id = current && current.length ? current[0].id : "";
                        if (lastId !== id) {
                            lastId = id;
                            // Set/remove active class
                            $(menuItems)
                                .parent().removeClass("active")
                                .end().filter("[href='#" + id + "']").parent().addClass("active");
                        }
                    }
                    else {
                        var nm = $("html").scrollTop();
                        var nw = $("body").scrollTop();
                        var fromTop = (nm > nw ? nm : nw) + topOffset;
                        // When the page pass one #id section, return all passed sections to scrollItems and save them into new array current
                        var current = $(scrollItems).map(function () {
                            if ($(this).offset().top <= fromTop)
                                return this;
                        });
                        // Get the most recent passed section from current array
                        current = current[current.length - 1];
                        var id = current && current.length ? current[0].id : "";
                        if (lastId !== id) {
                            lastId = id;
                            // Set/remove active class
                            $(menuItems)
                                .parent().removeClass("active")
                                .end().filter("[href='#" + id + "']").parent().addClass("active");
                        }
                    }
                }
                // Execute on load
                checkWidth();
                // Bind event listener
                $(window).resize(checkWidth);
            });
        }
    });
}


function responsiveMenu(){
  if(jQuery(window).width() < 768) {
    $('.product-filter-column').prependTo('.product-heading-row .container .row');
  }
  else { 
    $('.product-filter-column').prependTo('.product-list-row');
    if($('body').hasClass('mobile-open') ){
      $('body').removeClass('mobile-open no-scroll overflow-hidden-mobile');
      $('.overlay').removeClass('active');
     }
  }
     if(jQuery(window).width() < 1261) {
     if(!$('.mobile-lag').length > 0 ){
      const newDiv = document.createElement('ul');
      newDiv.className = 'mobile-lag d-flex aling-item-center';
      $(newDiv).insertAfter('.menu-close-icon');
      $('.languages , .currency').prependTo('.mobile-lag');
    }else{
       return false;
    }
  }
  else {
    $('.languages , .currency').appendTo('.header-right-inner');
    $('.mobile-lag').remove();
  }
}
jQuery(document).ready(function() {
  responsiveMenu();
});
jQuery(window).resize(function() {
  responsiveMenu();
});

function countDownIni(countdown) {
  $(countdown).each(function () {
    var countdown = $(this);
    var promoperiod;
    if (countdown.attr('data-promoperiod')) {
      promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
    } else if (countdown.attr('data-countdown')) {
      promoperiod = countdown.attr('data-countdown');
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      $(this).addClass('countdown-block');
      countdown.countdown(promoperiod, function (event) {
        // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
        countdown.html(event.strftime('<span><span>%D</span><span class="dots"> : </span></span>' + '<span><span>%H</span><span class="dots"> : </span></span>' + '<span><span>%M</span><span class="dots"> : </span></span>' + '<span><span class="second">%S</span></span>'));
      });
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) < 0) {
        $(this).parent().css('display','none');
     }
  });
}